import styled from "styled-components";

// Constants
import colors from "../../../../css/colors";

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

interface RowProps {
  padding?: string;
  spaceBetween?: boolean;
}

export const Row = styled.div<RowProps>`
  display: flex;
  flex-direction: row;
  padding: ${(props) => (props.padding ? props.padding : 0)};
  justify-content: ${(props) => (props.spaceBetween ? "space-between" : "initial")};
`;

export const OrganizationName = styled.div`
  font-size: 18px;
  cursor: pointer;
  color: ${colors.BLUE};
  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }
`;

export const Header = styled.h1`
  margin: 0 32px 16px 0;
  font-weight: 300;
  font-size: 36px;
`;
